import React from 'react';
import { AllhomesSearchListingCard, AllhomesSearchListingCardGraphQL } from '@domain-group/fe-co-allhomes-listing-card';
import { EventBoundary } from '@domain-group/fe-co-analytics';
import { jsx as ___EmotionJSX } from "@emotion/core";
var buildBadges = function buildBadges() {
  var annotations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return Object.fromEntries(annotations.map(annotation => [annotation.badge, true]));
};
export var WrappedListingCard = props => ___EmotionJSX(EventBoundary, {
  data: {
    badges: buildBadges(props.listing.annotations)
  }
}, ___EmotionJSX(AllhomesSearchListingCard, props));
export var WrappedListingCardGraphQL = props => ___EmotionJSX(EventBoundary, {
  data: {
    badges: buildBadges(props.property.listing.annotations)
  }
}, ___EmotionJSX(AllhomesSearchListingCardGraphQL, props));